// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u8qDm","toggle":"styles_toggle__1-Zui","preview":"styles_preview__3BynQ"};